import { render, staticRenderFns } from "./index.vue?vue&type=template&id=136d0f9d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&id=136d0f9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136d0f9d",
  null
  
)

export default component.exports